import React from 'react';

import useNow from '../../../pages/TournamentBoard/hooks/useNow';
import { elapsedSeconds, isRunning, ITimerState } from './presentationDrafts';
import { timerPhase } from './presentationRules';
import { SmallButton, Timer, TimerActions, TimerLabel } from './styles';

const clock = (seconds: number) =>
  `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;

const PHASE_LABEL = {
  presentation: 'Apresentação da equipe',
  questions: 'Perguntas da banca',
  over: 'Tempo esgotado',
};

interface IPresentationTimerProps {
  timer: ITimerState;
  onStart: () => void;
  onPause: () => void;
  onReset: () => void;
}

/**
 * Cronômetro da banca: 10 min de apresentação e 5 de perguntas (item 4.2.3).
 * O tempo vem do relógio a partir de quando começou (FE-64), então não zera
 * ao trocar de aba ou recarregar. A troca de fase muda a cor e é anunciada
 * para leitores de tela.
 */
const PresentationTimer: React.FC<IPresentationTimerProps> = ({
  timer,
  onStart,
  onPause,
  onReset,
}) => {
  // Só precisa redesenhar a cada segundo enquanto conta.
  const now = useNow(isRunning(timer) ? 1000 : 60_000);
  const elapsed = elapsedSeconds(timer, now);
  const running = isRunning(timer);
  const { phase, remaining } = timerPhase(elapsed);

  return (
    <Timer $phase={phase}>
      <TimerLabel role="status" aria-live="polite">
        {PHASE_LABEL[phase]}
        <strong>{phase === 'over' ? '0:00' : clock(remaining)}</strong>
      </TimerLabel>
      <TimerActions>
        {phase !== 'over' && (
          <SmallButton
            type="button"
            $primary
            onClick={running ? onPause : onStart}
          >
            {running ? 'Pausar' : elapsed === 0 ? 'Iniciar' : 'Continuar'}
          </SmallButton>
        )}
        {(elapsed > 0 || running) && (
          <SmallButton type="button" onClick={onReset}>
            Zerar
          </SmallButton>
        )}
      </TimerActions>
    </Timer>
  );
};

export default PresentationTimer;
